<script setup lang="ts">
    import { defineAsyncComponent } from 'vue';
    import TopBannerLeft from '../components/oferta/TopBannerLeft.vue' 
    import FormarBloque from '../components/oferta/FormarBloqueNeo.vue';  
    const MtrPlanEstudios = defineAsyncComponent(() => import('../components/oferta/MtrPlanEstudios.vue')) ; 
    const VerModelo = defineAsyncComponent(() => import('../components/oferta/VerModelo.vue')) ;
const PoliticaIA = defineAsyncComponent(() => import('../components/oferta/PoliticaIA.vue'))
    const CalendarioOferta = defineAsyncComponent(() => import('../components/oferta/CalendarioOferta.vue'))
    // const DescargaFolleto = defineAsyncComponent(() => import('../components/oferta/DescargaFolleto.vue')) ; 
    // const MtrModEjec = defineAsyncComponent(() => import('../components/oferta/MtrModEjec.vue')) ; 
    // const EgresadosHuma = defineAsyncComponent(() => import('../components/oferta/EgresadosHuma.vue')) ;
</script>

<template>
    <TopBannerLeft
        :img="'background-image: url(../../pagesImages/banner-educ1.jpg);'"
        :nivel="'Maestr&iacute;a en'"
        :carrera="'Educaci&oacute;n'"
        :frase="'El gran objetivo de la educaci&oacute;n no es el conocimiento, sino la acci&oacute;n'"
        :autor="'Herbert Spencer'"
    />

    <FormarBloque
        :img="'../../pagesImages/student9.jpg'"
        :link="'/requisitos-maestria'"
        :frase="'Forma líderes en Educación con capacidades para enfrentar los desafíos del conocimiento y transformar la práctica profesional'"
        :testo1="'La Maestría en Educación está diseñada para responder a los desafíos del contexto educativo actual, impulsando una gestión del conocimiento innovadora y flexible. Además, promueve el desarrollo de un pensamiento crítico, autónomo y reflexivo.'"
        :testo3="'Dirigida a profesionistas con título universitario, preferentemente en áreas como Educación, Administración, Ciencias Sociales o afines, así como a quienes desempeñan funciones laborales vinculadas directamente con el ámbito educativo y buscan fortalecer su perfil académico y profesional.'"
    />

    <div class="flex items-center justify-center my-10">
    </div>

    <MtrPlanEstudios
        :ejecutivo="true"
        :virtual="true"
    />

    
    <VerModelo
    ejec="/pagesImages/Programas/Maestria/maestria-educacion-ejecutivo_web.webp,/pagesImages/Programas/Maestria/maestria-educacion-ejecutivo_Cel.webp"
    virt="/pagesImages/Programas/Maestria/maestria-educacion-ejecutivo_web.webp,/pagesImages/Programas/Maestria/maestria-educacion-ejecutivo_Cel.webp"
    :escoT="false"
    :ejecT="true"
    :virtT="true" />

    
    <!-- <VerModelo
    ejec="/pagesImages/Programas/Maestria-ant/maestria-educacion-ejecutivo.webp"
    virt="/pagesImages/Programas/Maestria-ant/maestria-educacion-ejecutivo.webp"
    :escoT="false"
    :ejecT="true"
    :virtT="true" /> -->

    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col lg:px-4 px-8 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block font-serif text-[42px] text-hgold text-left" style="">Estructura académica</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-xl text-left mb-3">(Bloques trimestrales):</span>
                        </h2>
                        <ul class="list-disc pl-5 mb-4">
                            <li><b>Bases de la Educación:</b> Cimientos teóricos y socioculturales, modelos educativos, la sociedad del conocimiento y bases filosóficas de la Educación.</li>
                            <li><b>Gestión Educativa: </b>Liderazgo y administración de instituciones, introducción a la gestión educativa, gestión del capital humano y dirección de centros educativos.</li>
                            <li><b>Sistemas Educativos:</b> Perspectiva global y nacional, política educativa internacional, sistemas educativos mundiales y mexicano.</li>
                            <li><b>Calidad educativa:</b> Excelencia y evaluación pedagógica, teoría de la calidad educativa, gestión de la calidad educativa y evaluación de la calidad educativa.</li>
                            <li><b>Investigación e Innovación:</b> Soluciones transformadoras, proyecto de investigación educativa, diagnóstico de necesidades en educación e innovación educativa.</li>
                            <li><b>Seminario de titulación:</b> Desarrollo de un proyecto aplicado para la obtención del grado.</li>
                            <!-- <li><b>Seminario de Inteligencia Artificial.</b> Conocimiento, comprensión y aplicación de las herramientas de Inteligencia Artificial en entornos académicos, profesionales y laborales, fortaleciendo las habilidades y capacidades.</li> -->
                        </ul>
                        <!-- <p>
                            Este programa está diseñado para formar especialistas en contabilidad con una visión estratégica, capaces de responder a los desafíos del entorno fiscal, financiero y corporativo con un enfoque integral y actualizado.
                        </p> -->
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/estructura-academica-educacion.webp" alt="Alt pendiente" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
	</section>
    <CalendarioOferta nombre="Maestría en Educación" 
  :inicios="[false, false, false, true, false, false, true, false]"></CalendarioOferta>

    <!-- <MtrModEjec class="mb-16" />

    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block text-hgold text-left font-serif mb-3 text-[42px]">Metodología</span>
                        </h2>
                        <p class="mb-4">
                            El modelo ejecutivo se desarrolla bajo la siguiente estructura:
                        </p>
                        <ul class="list-disc pl-5 mb-4">
                            <li>Consta de 6 bloques trimestrales.</li>
                            <li>Cada bloque equivale a tres materias fusionadas, impartidas por un especialista en la materia.</li>
                            <li>Se imparten clases un día a la semana, tres horas de clases presenciales.</li>
                            <li>El modelo educativo tiene una duración de diez semanas de clases, y una semana adicional culminando con una evaluación final.</li>
                            <li>La evaluación se compone de participación en clase, foros, trabajos y examen final, integrando así un proceso de aprendizaje integral.</li>
                        </ul>
                        <p>
                            Este modelo permite a los estudiantes desarrollar habilidades especializadas con un enfoque práctico y estratégico, alineado con las exigencias del mundo profesional actual.
                        </p>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/universidad-fisica-virtual.webp" alt="Estudiantes de maestría en alta dirección corporativa universidad Humanitas" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
	</section> -->
    
    <section class="lg:flex items-center justify-center bg-cover bg-[center] bg-no-repeat mb-16" style="background-image: url(/pagesImages/madin3.jpg); position: relative; background-attachment: fixed; background-position: left; background-repeat: no-repeat; background-size: cover; overflow: hidden; transition: transform 0.3s ease;">
        <div class="lg:flex items-center justify-center w-full h-full my-16">
            <div class="lg:flex items-center justify-between w-full max-w-[1200px]">
                <img src="/pagesImages/perfil-egresado-maestrias.webp" alt="Egresados de maestría en Educación" class="lg:p-0 w-full lg:max-w-[520px] md:px-16 px-6 pt-6"/>
                <div class="flex flex-col lg:justify-start justify-center items-center lg:items-start lg:w-[50%] w-full lg:my-24 py-12 text-justify lg:px-0  px-8">
                    <h2>
                        <span class="block text-[28px] text-hwine leading-none text-center md:text-left">Perfil del egresado de la maestría en</span>
                        <span class="sr-only whitespace-nowrap">&nbsp;</span>
                        <span class="block text-hwine text-[42px] mb-4 leading-tight text-center md:text-left font-serif ">Educación</span>
                    </h2>
                    <p class="text-justify text-gray-800 lg:hyphens-manual hyphens-auto">Contará con una visión global y actualizada de las tendencias en gestión educativa, lo que le permitirá analizar contextos complejos y proponer soluciones innovadoras orientadas a mejorar la calidad de los procesos formativos. <br>Estará capacitado para diseñar y desarrollar proyectos educativos que respondan eficazmente a los desafíos de la administración escolar, integrando de manera estratégica saberes pedagógicos, psicológicos y administrativos.</p>
                    <br>
                    <router-link to="/contacto">
                        <div class="flex items-center justify-center w-[140px] h-[35px] hover:bg-hwine bg-hgold text-white  text-lg transition duration-300 ease-in-out">
                            <span>Inscr&iacute;bete</span>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </section>

    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col lg:px-4 px-8 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between w-full">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block leading-none text-left text-[28px]" style="">Cinco razones para elegir</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-hgold text-left font-serif mb-3 text-[42px]">Universidad Humanitas:</span>
                        </h2>
                        <ul class="list-disc pl-5 mb-4">
                            <li>Modelo educativo especializado.</li>
                            <li>Excelencia académica.</li>
                            <li>Instalaciones de primer nivel.</li>
                            <li>Costos accesibles.</li>
                            <li>Acreditaciones reconocidas (SEP, ESR y GPTW).</li>
                        </ul>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/beneficios-estudiar-universidad-humanitas.webp" alt="Beneficios de estudiar en Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
	</section>
    <PoliticaIA />
</template>

<style scoped>
</style>